import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Button } from '../ui/Button';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function CTA() {
  const { isDark } = useTheme();

  return (
    <section className="py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`relative p-12 rounded-3xl overflow-hidden text-center ${
          isDark 
            ? 'bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-800' 
            : 'bg-gradient-to-br from-gray-50 to-white border border-gray-200'
        }`}>
          {/* Éléments décoratifs */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>

          {/* Contenu */}
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-8">
              <Sparkles className="w-4 h-4 text-primary-600" />
              <span className="text-sm font-medium text-primary-600 dark:text-primary-400">
                Prêt à transformer votre équipe ?
              </span>
            </div>

            <h2 className={`text-3xl lg:text-4xl font-bold mb-4 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Commencez dès aujourd'hui
            </h2>
            
            <p className={`text-lg mb-8 max-w-2xl mx-auto ${
              isDark ? 'text-gray-300' : 'text-gray-600'
            }`}>
              Rejoignez les 500+ équipes qui ont déjà augmenté leur productivité de 35%
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="xl" className="group">
                Réserver une démo
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button variant="outline" size="xl">
                Activer mon CRM
              </Button>
            </div>

            <p className={`text-sm mt-6 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              🚀 Sans engagement • Configuration en 5 minutes • Support prioritaire
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}